import useUDTopics from "hooks/UD/useUDTopics";
import useUDCompareTopics from "hooks/UD/useUDCompareTopics";
import { findEdition2VariableId } from "../utils/findEdition2VariableId";
import { getKeyVariablesToUse } from "../utils/getKeyVariablesToUse";

import Loader from "components/Loader";
import Options from "components/Options";
import ExpandableBox from "components/ExpandableBox";

const getOptions = (keyVariables, isCompareMode = false, hasCommonKeyVars = false) => {
   if (!keyVariables) return [];
   
   if (isCompareMode && hasCommonKeyVars) {
      // W trybie porównania z common_key_variables - format z mapowaniem
      return keyVariables.map( kv => ({
         value: kv.edition1, // Używamy ID z pierwszej edycji jako wartości
         label: kv.name || "Zmienna", // API powinno zwracać nazwę, jeśli nie, używamy domyślnej
         tooltip: kv.tooltip,
         edition1_id: kv.edition1,
         edition2_id: kv.edition2
      }));
   }
   
   // Standardowy format (dla trybu single lub porównania bez common_key_variables)
   return keyVariables.map( k => ({
      value: k.id,
      label: k.name,
      tooltip: k.tooltip
   }));
};

export default function Step2({ params, errors, onChange }) {

   const isCompareMode = params?.compare_mode === "compare";
   const { d: topics } = useUDTopics( isCompareMode ? null : params.edition );
   const { d: compareTopics } = useUDCompareTopics( 
      isCompareMode ? params.edition : null, 
      isCompareMode ? params.edition2 : null 
   );
   
   // W trybie porównania potrzebujemy topics z obu edycji do mapowania ID
   const { d: topicsEdition1 } = useUDTopics( isCompareMode ? params.edition : null );
   const { d: topicsEdition2 } = useUDTopics( isCompareMode ? params.edition2 : null );

   const displayTopics = isCompareMode ? compareTopics : topics;

   return displayTopics ? (
      <>
         <p> Wybierz kluczowe zmienne, których rozkład będziesz oglądać na wykresach. Możesz wybrać maksymalnie jedną zmienną - na finalnym wykresie będziesz mógł zmienić widok. </p>
         
         { displayTopics && !!displayTopics.length && 
            displayTopics.map(({ id, name: label, keyVariables, common_key_variables, children }) => {
               const varsToUse = getKeyVariablesToUse(common_key_variables, keyVariables, isCompareMode);

               const onOptionsChange = ( n, v ) => {
                  onChange( "key_variable_ids", v );
                  // W trybie porównania musimy również zapisać mapowanie do edition2
                  if (isCompareMode && v && v.length > 0) {
                     const edition2Id = findEdition2VariableId(v[0], displayTopics, topicsEdition1, topicsEdition2);
                     onChange({
                        key_variable_ids: v,
                        key_variable_id: v[0],
                        key_variable_id_edition2: edition2Id || v[0]
                     });
                  }
               };

               const hasCommonKeyVars = isCompareMode && common_key_variables && common_key_variables.length > 0;
               
               return (
                  <div key={ id }>  
                     {varsToUse && varsToUse.length > 0 && (
                        <Options
                           multiple 
                           name={ "topic_" + id }
                           value={ params.key_variable_ids || []}
                           label={ label }
                           options={ getOptions( varsToUse, isCompareMode, hasCommonKeyVars )}
                           onChange={ onOptionsChange }
                        />
                     )}

                     { children && !!children.length &&
                        children.map(({ id: childId, name, keyVariables: childKeyVars, common_key_variables: childCommonVars }) => {
                           const childVarsToUse = getKeyVariablesToUse(childCommonVars, childKeyVars, isCompareMode);
                           const childHasCommonKeyVars = isCompareMode && childCommonVars && childCommonVars.length > 0;
                           
                           // Dla children używamy ich własnych common_key_variables
                           const onChildOptionsChange = ( n, v ) => {
                              onChange( "key_variable_ids", v );
                              // W trybie porównania musimy również zapisać mapowanie do edition2
                              if (isCompareMode && v && v.length > 0) {
                                 const edition2Id = findEdition2VariableId(v[0], displayTopics, topicsEdition1, topicsEdition2);
                                 onChange({
                                    key_variable_ids: v,
                                    key_variable_id: v[0],
                                    key_variable_id_edition2: edition2Id || v[0]
                                 });
                              }
                           };
                           
                           return childVarsToUse && childVarsToUse.length > 0 ? (
                              <ExpandableBox
                                 key={ childId } 
                                 heading={ name }
                                 style={{ marginTop: "10px" }}   
                                 default_open={false}
                              >
                                 <Options
                                    multiple
                                    name={ "topic_" + childId }
                                    value={ params.key_variable_ids || []}
                                    options={ getOptions( childVarsToUse, isCompareMode, childHasCommonKeyVars )}
                                    onChange={ onChildOptionsChange }
                                 />
                              </ExpandableBox>
                           ) : null;
                        })
                     }
                  </div>
               )
            })
         }

         { errors.key_variable_ids && 
            <div className="error" style={{ textAlign: "center" }}> { errors.key_variable_ids } </div>
         }
      </>
   ) : <Loader/>
}